import React, { useState, useEffect, memo } from 'react';
import { useLocation, useHistory } from 'react-router';

// Constants
// import PageUrlsConstants from 'Shared/constants/PageUrls.constants';

// Helpers
import { toggleIntercom } from 'Shared/helpers';

// Utils
import PageUrlsUtil from 'Shared/utils/PageUrls.utils';
import { useCopyToClipboard } from 'Shared/utils/hooks/use-copy-to-clipboard';

// Hooks
import { useGoal } from 'Shared/utils/hooks/use-goal';
import { useGoalDetailPanel } from 'Shared/utils/hooks/use-goal-detail-panel';

// Components
import { WpDrawerV2, WpDrawerV2Body } from 'Wpds/components/drawer';
import GoalDetailPanelContent from './GoalDetailPanelContent';
import { WpButton } from 'Wpds/components/button';
import WpIcon from 'Wpds/components/icon/WpIcon';
import GoalDetailPanelBreadcrumbs from './GoalDetailPanelBreadcrumbs';
import GoalDetailPanelLoading from './loading/GoalDetailPanelLoading';
// import ItemDoesntExistError from 'Shared/components/ItemDoesntExistError/ItemDoesntExistError';
import GoalActionsDropdown from '../Goals/GoalActionsDropdown/GoalActionsDropdown';

const GoalDetailPanel = () => {
  const history = useHistory();
  const { pathname } = useLocation();
  const { handleClosePanel } = useGoalDetailPanel();

  const [previousSlug, setPreviousSlug] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isSwitching, setIsSwitching] = useState(false);

  const isOpen = pathname.includes('/goals/') && pathname.includes('/detail');

  const slug = isOpen ? pathname.match(/\/goals\/(.*)\/detail/)[1] : null;
  const { goal } = useGoal({ slug, fetchOnMount: true });
  const goalUrl = slug && goal ? `${window.location.origin}${PageUrlsUtil.makeGoalDetailPageUrl(slug)}` : '';

  const showLoading = isLoading || isSwitching;

  const onClickLinkToGoal = () => {
    history.push({ pathname: PageUrlsUtil.makeGoalDetailPageUrl(slug), state: { modal: true } });
  };

  useEffect(() => {
    if (isOpen && !goal) setIsLoading(true);
    if (isOpen && goal && slug && slug === goal.slug) {
      setIsLoading(false);
    }
  }, [isLoading, isOpen, slug, goal]);

  useEffect(() => {
    if (isOpen && slug !== previousSlug) {
      setIsSwitching(true);
    }
  }, [isOpen, goal, slug, previousSlug]);

  useEffect(() => {
    if (isSwitching) setTimeout(() => setIsSwitching(false), 600);
  }, [isSwitching]);

  useEffect(() => {
    if (goal) setPreviousSlug(goal.slug);
  }, [goal]);

  const { onCopyTextToClipboard: handleCopyLinkClick } = useCopyToClipboard({
    textToCopy: goalUrl,
  });

  useEffect(() => {
    if (isOpen) toggleIntercom({ show: false });
    else toggleIntercom({ show: true });
  }, [isOpen, goal]);

  return (
    <WpDrawerV2
      isOpen={isOpen}
      withAnimation={false}
      toggleIsOpen={handleClosePanel}
      width={604}
      title={isOpen && goal && <GoalDetailPanelBreadcrumbs goal={goal} />}
      actionButtons={
        isOpen ? (
          <>
            {goal && <GoalActionsDropdown goal={goal} />}
            {goalUrl && (
              <WpButton variant="tertiary" size="sm" onClick={handleCopyLinkClick} square>
                <WpIcon name="link" />
              </WpButton>
            )}
            {goal && (
              <WpButton variant="tertiary" size="sm" onClick={onClickLinkToGoal} square>
                <WpIcon name="expand-alt" />
              </WpButton>
            )}
          </>
        ) : null
      }
    >
      <WpDrawerV2Body>
        {/* {hasError ? (
        // TODO: Josh, Why this is not routing correctly when you refresh the page
        <ItemDoesntExistError
          title="We couldn’t find this Goal."
          description="You either no longer have access to it, or it has been deleted."
        />
      ) : (
        <> */}
        {showLoading && <GoalDetailPanelLoading />}
        {!showLoading && isOpen && goal && <GoalDetailPanelContent />}
        {/* </>
      )} */}
      </WpDrawerV2Body>
    </WpDrawerV2>
  );
};

export default memo(GoalDetailPanel);
